import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicyclePickup.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicyclePickup' */ './component')],
	render: ([AdminBicyclePickup]) => <AdminBicyclePickup />,
};

export default routes;
